import React, { memo, useState } from "react";
import { Result, Button, Alert } from "antd";

interface ErrorComponent {
  error?: any;
  statuss?: number;
}
function ErrorComponent(props: ErrorComponent) {
  const { error, statuss } = props;
  const useErrorHandler = () => {
    if ((error && error.response) || statuss) {
      const status = statuss || error.response.status;
      switch (status) {
        case 400:
          return (
            <>
              <Result
                status="404"
                title="400"
                subTitle="رکویست درخواستی مشکل دارد"
              />
            </>
          );
        case 401:

        case 403:
          return (
            <Result
              status="403"
              title="403"
              subTitle="متاسفانه شما دسترسی لازم برای مشاهده این صفحه را ندارید"
            />
          );
        case 404:
          return (
            <Result
              status="404"
              title="404"
              subTitle="متاسفانه آن چه شما دنبال آن بودید را ما پیدا نکردیم !"
            />
          );

        case 500:
          return (
            <Result
              status="500"
              title="500"
              subTitle="در سرور خطایی روی داده است"
            />
          );
      }
    } else {
      return (
        <Result status="500" title="خطای ناشناخته" subTitle="مجددا تلاش کنید" />
      );
    }
  };
  return useErrorHandler();
}

export default ErrorComponent;
